export const formatCount = (n) => n.toLocaleString("en-US");

// A part's share of the total; a small but non-zero part reads "<1%" rather than "0%"
export const formatShare = (value, total) => {
  if (!total || !value) return "0%";
  const percent = Math.round((value / total) * 100);
  return percent === 0 ? "<1%" : `${percent}%`;
};
